export default {
  NONE: 'none',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger'
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvc3JjL0ludGVudC5qcyJdLCJuYW1lcyI6WyJOT05FIiwiU1VDQ0VTUyIsIldBUk5JTkciLCJEQU5HRVIiXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7QUFDYkEsUUFBTSxNQURPO0FBRWJDLFdBQVMsU0FGSTtBQUdiQyxXQUFTLFNBSEk7QUFJYkMsVUFBUTtBQUpLLENBQWYiLCJmaWxlIjoiSW50ZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICBOT05FOiAnbm9uZScsXG4gIFNVQ0NFU1M6ICdzdWNjZXNzJyxcbiAgV0FSTklORzogJ3dhcm5pbmcnLFxuICBEQU5HRVI6ICdkYW5nZXInXG59XG4iXX0=